import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.grey[100],
    borderRadius: 4,
    boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)',
    marginBottom: 32,
    // height: 320,
    padding: 20
  },
  filterContainer: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 20,
    alignItems: 'center'
  },
  applyButton: {
    minHeight: 38,
    width: 116,
    fontSize: 16,
    color: `${theme.palette.grey[200]}`
  },
  resetButton: {
    minHeight: 38,
    width: 116,
    fontSize: 16,
    color: `${theme.palette.grey[700]}`
  },
  typographyOfButton: {
    color: `${theme.palette.grey[200]} !important`
  },
  typographyOfButtonAfterSelectDate: {
    color: `${theme.palette.grey[300]} !important`,
    fontSize: 12,
    fontWeight: 500
  },
  typographyOfButtonAfterSelectDateForArrivalDateAndDeparture: {
    color: `${theme.palette.grey[300]} !important`,
    fontSize: 13,
    fontWeight: 700
  },
  arrowIcon: {
    marginBottom: '0px !important',
    marginLeft: '20px !important'
  },
  ButtonsContainer: {
    marginTop: 20,
    display: 'flex',
    flexDirection: 'row',
    gap: 0,
    justifyContent: 'flex-end',
    '& Button:first-child': {
      minHeight: 38,
      width: 116,
      fontSize: 16,
      color: `${theme.palette.grey[700]}`
    },
    '& Button:last-child': {
      minHeight: 38,
      width: 116,
      fontSize: 16,
      color: `${theme.palette.grey[200]}`
    }
  },
  twoColumnRow: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 20,
    alignItems: 'center'
  },
  threeColumnRow: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: 20,
    alignItems: 'center'
  }
}))

export default useStyles
